import * as types from '../../../lib/actionTypes.es6';

export var getCommissionStatementRequest = function(payload) {
  return { type: types.GET_COMMISSION_STATEMENT_REQUEST, payload: payload };
};

export var getCommissionStatementSuccess = function(payload) {
  return { type: types.GET_COMMISSION_STATEMENT_SUCCESS, payload: payload };
};

export var getCommissionStatementFailed = function(error) {
  return { type: types.GET_COMMISSION_STATEMENT_FAILURE, payload: error };
};

export var resetCommissionStatement = function() {
  return { type: types.RESET_COMMISSION_STATEMENT };
};
